import React from "react";

export default function Spinner() {
  return (
    <>
      <div className='spin-container'>
        <div className='spinner-modern'>
          <div className='spinner-circle'></div>
        </div>
        <span className='spinner-text'>carregando...</span>
      </div>
    </>
  );
}